
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import Formsy from 'formsy-react';
import { Heading, Header, Slider, Section, MapsItems, FormValidation, FormRegister,
  MapDetail, Field, Loader } from './index';
import { data } from '../utils/config';

import REQUEST from '../api/requests';
import { getDataUri } from '../utils/_helpers';
import Errors from '../utils/errors';
import Success from '../utils/success';

const Steps = ({ steps, active, completed = []}) => {
  if (!steps) return null;
  return (
    <div className="steps">
      {steps.map((step, i) => {
        const activeClass = active-1 === i ? 'steps_active' : ''; 
        const name = step.name || '';
        const invisible = step.invisible ? 'steps_invisible' : '';
        const successClass = step.success ? 'steps_success' : '';
        return <button key={i} style={[invisible]} className={`${activeClass} ${successClass} ${invisible}`}>{name}<span/></button>
      })}
    </div>
  )
}

const validate = (validations) => validations ? { validations } : {};
const steps = [];

const defaultState = {
  page: 0,
  files: [],
  key: null,
  title: '',
  steps: steps,
  validation: {},
  loading: false,
  private: {},
  public: {},
  system: {},
  relatedData: {},

  errorOnVerifying: '',
  successOnVerifying: false,

  loadingSubmitData: false,
  errorOnSubmitData: '',
  successOnSubmitData: '',
};

export default class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...defaultState,
      steps: props.stepsRegister || [],
    }

    this.related = false;

    this.goTo = this.goTo.bind(this);
    this._renderRegisterSection = this._renderRegisterSection.bind(this);
    this.resetState = this.resetState.bind(this);
    this.setValid = this.setValid.bind(this);
    // this.verifyQR = this.verifyQR.bind(this);
    this.loading = this.loading.bind(this);
    this.tryVerifyQR = this.tryVerifyQR.bind(this);
    this.generateBase64 = this.generateBase64.bind(this);
    this.fieldOnChange = this.fieldOnChange.bind(this);
    this.tryUpdateQR = this.tryUpdateQR.bind(this);
    this.acceptDataFromRelated = this.acceptDataFromRelated.bind(this);
    this.reset = this.reset.bind(this);
  }

  reset() {
    const steps = this.props.stepsRegister.map((step) => ({ ...step, success: false }));
    this.setState({
      ...defaultState,
      steps,
    });
  }

  loading(status) {
    this.setState({ loading: status || false });
  }

  generateBase64(file) {
    const that = this;
    return new Promise((resolve, reject) => {
      if (!file) reject(Errors.noFileProvided);
      getDataUri(file.preview, (base64) => {
        resolve(base64);
      });
    })
  }

  acceptDataFromRelated(res) {
    if (this.props.relatedSuccess && res) {
      const { data = {} } = res.data;
      this.related = true;
      this.setState({
        ...this.state,
        page: this.state.page === 0 ? 1 : this.state.page,
        steps: this.props.stepsValidate,
        loading: false,
        private: data.private || {},
        public: data.public || {},
        system: data.system || {},
        relatedData: res.data,
      });
    }
  }

  tryUpdateQR(data, update) {
    const that = this;
    this.setState({
      loadingSubmitData: true,
      errorOnSubmitData: '',
    });

    this.props.onUpdateQR(data, update)
      .then((res) => {
        if (res.data && res.status === 200 && res.data.status) {
          this.setState({
            successOnSubmitData: true,
          }, () => {
            that.goTo(this.state.steps[this.state.page-1].next, {
              loadingSubmitData: false,
              successOnSubmitData: res.data.message,
            });
          });
        } 
        else if (res.data) {
          this.setState({
            loadingSubmitData: false,
            errorOnSubmitData: res.data.message || res.data.errorMessage,
          });
        }
        else {
          this.setState({
            loadingSubmitData: false,
            errorOnSubmitData: Errors.default,
          });
        }
      })
      .catch((err) => {
        console.log('err ', err)
        this.setState({
          loadingSubmitData: false,
          errorOnSubmitData: err.message,
          successOnSubmitData: '',
        });
      });
  }

  tryVerifyQR(file) {
    const that = this;
    this.setState({
      loading: true,
      successOnVerifying: false,
      errorOnVerifying: '',

    })
    this.generateBase64(file)
      .then((data) => {
        this.props.onVerifyQr(data)
          .then(res => {
            if (res.data && res.status === 200 && res.data.status) {
              this.setState({
                successOnVerifying: true,
              }, () => {
                setTimeout(() => {
                  const isRegister = this.state.key === "register";
                  const { data = {} } = res.data;
                  that.goTo(this.state.steps[this.state.page-1].next, {
                    loading: false,
                    private: isRegister ? {} : data.private || {},
                    public: isRegister ? {} : data.public || {},
                    system: data.system || {},
                  });
                }, 1000); // defer to show the success message
              });
            } 
            else if (res.data) {
              this.setState({
                loading: false,
                errorOnVerifying: res.data.message || res.data.errorMessage,
              });
            }
            else {
              this.setState({
                loading: false,
                errorOnVerifying: Errors.default,
              });
            }
          })
          .catch(err => {
            this.setState({
              loading: false,
              errorOnVerifying: err.message,
            });
          });
      })
      .catch((err) => {
        this.setState({
          loading: false,
          errorOnVerifying: err.message,
          successOnVerifying: '',
        });
      });
  }

  setValid(page, status) {
    this.setState({
      ...this.state,
      steps: [ ...this.state.steps.map((item, i) => {
        if (i === page) {
          item.valid = status;
        }
        return item;
      })]
    });
  }

  goTo(page, state) {
    return new Promise((resolve, reject) => {
      const steps = this.state.steps.slice();
      if (page > this.state.page && steps[page-1]) {
        const prev = (steps[page-1].back -1) >= 0 ? steps[page-1].back -1 : page-1;
        steps[prev].success = true;
      } else if (steps.length > 0) {
        steps[page].success = false;
      }
      this.setState({
        ...this.state,
        page,
        ...state,
      }, () => {
        resolve();
      });
    });
  }

  resetState() {
    this.related = false;
    this.setState({ ...defaultState });
  }

  onDrop(files) {
    this.setState({
      ...this.state,
      system: {},
      private: {},
      public: {},
      files,
      successOnVerifying: false,
    }, () => {
      // set valid when on drop 
      this.setValid(this.state.page, true);
    });
  }

  fieldOnChange(e, val) {
    if (!e) return;
    const target = e.target || e.extra || {};
    const getStateStep = this.state.steps[this.state.page-1];
    const currentStep = target.step || getStateStep.key|| undefined;
    if (currentStep !== undefined && target.name) {
      this.setState({ 
        ...this.state,
        [currentStep]: {
          ...this.state[currentStep],
          [target.name]: val,
        }
      });
    }
  }

  _renderRegisterSection() {
    let element = null;
    const that = this;
    const steps = this.state.steps;
    const selectedPage = this.state.page-1;
    switch(this.state.page) {
      case 0:
        element = (
          <div className="scroller_section register">
            <p>If you have recently purchased one of our prints please update the certificate information here. Changing the print owner change must be confirmed by the previous owner so we recommend that you do this as soon as possible after purchasing. To make changes to the certificate please first take a photo of the QR code found on the back of the print. </p>            <button onClick={(e) => {
              e.preventDefault();
              this.goTo(1);
            }} className="button button-form"><span>Next</span><strong><i className="icon fas fa-angle-right" /></strong></button>
          </div>
        )
        break;
      case 1:
        element = (
          <div className="scroller_section register form">
            <div className="row register_selection">
              <div className="col-sm-12">
                <h3 className="register_selection_title line-down">Register as a new user</h3>
                <p className="register_selection_desc">If you have recently acquired one of our prints and would like to register your ownership. The current owner will need to confirm the change of ownership.</p>
                <button disabled={this.props.isDisableRegister} onClick={(e) => {
                  this.props.onDisableValidation(true);
                  const state = {};
                  if (this.related) {
                    state.private = {}
                    state.public = {}
                  }
                  this.goTo(this.state.steps[selectedPage].next, {
                    key: 'register',
                    title: 'Register as a new user',
                    ...state,
                  });        
                  e.preventDefault();
                }} className="button button-form"><span>Next</span><strong><i className="icon fas fa-angle-right" /></strong></button>
              </div>
              <div className="col-sm-12">
                <h3  className="register_selection_title line-down">Update my certification information</h3>
                <p className="register_selection_desc">If you need to update the certificate of a print you already own. You can update your contact information or you can record that you are interested in selling the print.</p>
                <button disabled={this.props.isDisableRegister} onClick={(e) => {
                  this.props.onDisableValidation(true);
                  const state = {};
                  if (this.related) {
                    const { data = {} } =  this.state.relatedData;
                    state.private = data.private || {};
                    state.public = data.public || {};
                  }
                  this.goTo(this.state.steps[selectedPage].next, {
                    key: 'update',
                    title: 'Update my certification information',
                    ...state,
                  });
                  e.preventDefault();
                }} className="button button-form"><span>Next</span><strong><i className="icon fas fa-angle-right" /></strong></button>
              </div>
            </div>
          </div>
        )
        break;
      case 2: {
        const canSubmit = this.state.steps[this.state.page].valid ? true : false;
        const tickIcon = !this.state.successOnVerifying ? <strong><i className="icon fas fa-angle-right" /></strong> : <strong><i className="icon fas fa-check" /></strong>;
        element = (
          <div className="scroller_section register form">
            <div className="row register_upload">
              <div className="col-sm-5 dropzone">
                <Dropzone 
                  multiple={false}
                  onDrop={this.onDrop.bind(this)}
                  className='dropzone-area'
                  accept="image/jpeg, image/png"
                  activeClassName='dropzone-area-active'
                  acceptClassName='dropzone-area-active'
                > 
                  {this.state.files.length > 0 ? 
                    <span className="dropzone-area_filename">{this.state.files[0].name}</span> :
                    <p className="dropzone-area_text">Drop or click to upload qr image.</p>
                  }
                </Dropzone>
              </div>
              <div className="col-sm-3">
                <button onClick={(e) => {
                  e.preventDefault();
                  this.tryVerifyQR(this.state.files[0]);
                }} disabled={!canSubmit || this.state.loading} className={`button button-form ${this.state.successOnVerifying ? 'button-success' : ''}`}>
                  <span>Next</span>{this.state.loading && !this.state.successOnVerifying ? <Loader height={20} strokeWidth={3} stroke={'#fff'} /> : tickIcon}
                </button>
              </div>
            </div>
            {this.state.errorOnVerifying && <span className="error-helper">{this.state.errorOnVerifying}</span>}

            <div className="row">
              <div className="col-sm-6">
                <button onClick={(e) => {
                  e.preventDefault();
                  this.props.onDisableValidation();
                  that.goTo(this.state.steps[selectedPage].back, {
                    private: {},
                    public: {},
                    files: [],
                    syste: {},
                    successOnVerifying: false,
                    title: 'Register or update',
                    successOnSubmitData: '',
                    errorOnVerifying: '',
                  });
                }} className="button button-form"><i className="icon fas fa-angle-left"></i></button>
              </div>
            </div>
          </div>
        )
        break;
      }
      case 3: {
        const canSubmit = this.state.steps[this.state.page].valid ? true : false;
        element = (
          <div className="scroller_section register form">
            <Formsy
              onSubmit={(data) => {
                that.goTo(this.state.steps[selectedPage].next);
              }}
              onValid={(data) => {
                if (!canSubmit) {
                  that.setValid(that.state.page, true);
                }
              }} 
              onInvalid={(data) => {
                if (canSubmit) {
                  that.setValid(that.state.page, false);
                }
              }}
            >
              <div className="row register_license">
                <div className="col-sm-6">
                  {Object.keys(data.license.left).map((itemKey, i) => {
                    const item = data.license.left[itemKey];
                    const value = this.state.private[itemKey] || '';
                    const validations = validate(item.validations);
                    const disabled = item.disable ? item.disable.indexOf(this.state.key) >= 0 : false;
                    return (
                      <Field step='private' disabled={disabled} {...validations} onChange={this.fieldOnChange} mask={item.mask} value={value} 
                        key={i} item={item} name={item.key} required={item.required || false} itemKey={itemKey} />
                    )
                  })}
                </div>
                <div className="col-sm-6">
                  {Object.keys(data.license.right).map((itemKey, i) => {
                    const item = data.license.right[itemKey];
                    const value = this.state.private[itemKey] || '';
                    const validations = validate(item.validations);
                    const disabled = item.disable ? item.disable.indexOf(this.state.key) >= 0 : false;
                    return (
                      <Field step='private' disabled={disabled} {...validations} onChange={this.fieldOnChange} mask={item.mask}
                        value={value} key={i} item={item} name={item.key} required={item.required || false} itemKey={itemKey} />
                    )
                  })}
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <button onClick={(e) => {
                    e.preventDefault();
                    this.goTo(this.state.steps[selectedPage].back);
                  }} className="button button-form"><i className="icon fas fa-angle-left"></i></button>
                </div>
                <div className="col-6" style={{ textAlign: 'right'}}>
                  <button type="submit" className="button button-form" disabled={!canSubmit}><span>Next</span><strong><i className="icon fas fa-angle-right" /></strong></button>
                </div>
              </div>
            </Formsy>
          </div>
        )
        break;
      }
      case 4: {
        const canSubmit = this.state.steps[this.state.page].valid ? true : false;
        element = (
          <div className="scroller_section register form">
            <Formsy
              onSubmit={(data) => {
                that.setState({
                  public: {
                    ...data,
                  }
                }, () => {
                  const token = this.state.system.token;
                  const data = {
                    token,
                    ...this.state.private, 
                    ...this.state.public
                  };
                  if (data.s_price && typeof data.s_price === 'string') {
                    data.s_price = parseFloat(data.s_price.replace(/,/g, ''));
                  }
                  if (this.state.key === 'register') {
                    this.tryUpdateQR(data);
                  } else {
                    this.tryUpdateQR(data, true);
                  }
                })
              }}
              onValid={(data) => {
                if (!canSubmit) {
                  that.setValid(that.state.page, true);
                }
              }} 
              onInvalid={(data) => {
                if (canSubmit) {
                  that.setValid(that.state.page, false);
                }
              }}
            >
              <div className="row register_license">
                <div className="col-sm-6">
                  {Object.keys(data.public.left).map((itemKey, i) => {
                    const item = data.public.left[itemKey];
                    const value = this.state.public[itemKey] || '';
                    const validations = validate(item.validations);
                    const disabled = item.disable ? item.disable.indexOf(this.state.key) >= 0 : false;
                    return (
                      <Field step='public' disabled={disabled} {...validations} onChange={this.fieldOnChange} mask={item.mask}
                        value={value} key={i} item={item} name={item.key} required={item.required || false} itemKey={itemKey} />
                    )
                  })}
                </div>
                <div className="col-sm-6">
                  {Object.keys(data.public.right).map((itemKey, i) => {
                    const item = data.public.right[itemKey];
                    const value = this.state.public[itemKey] || '';
                    const validations = validate(item.validations);
                    const disabled = item.disable ? item.disable.indexOf(this.state.key) >= 0 : false;
                    const relateTo = item.relateTo ? item.relateTo : '';
                    const isRelatedValue = this.state.public[relateTo] || false; 
                    return (
                      <Field step='sale' disabled={disabled} {...validations} onChange={this.fieldOnChange} mask={item.mask}
                        value={value} key={i} item={item} name={item.key} required={item.required || isRelatedValue || false} itemKey={itemKey} />
                    )
                  })}
                </div>
                {/* <div className="col-sm-12 disclaimer">
                  <h3 className="line-down">Disclaimer</h3>
                  <p>{data.disclaimers.first}</p>

                  <div className="cntr">
                    <label htmlFor="cbx" className="label-cbx">
                      <input id="cbx" onChange={this.fieldOnChange} type="checkbox" name="disclaimer" className="invisible" />
                      <div className="checkbox">
                        <svg width="20px" height="20px" viewBox="0 0 20 20">
                          <path d="M3,1 L17,1 L17,1 C18.1045695,1 19,1.8954305 19,3 L19,17 L19,17 C19,18.1045695 18.1045695,19 17,19 L3,19 L3,19 C1.8954305,19 1,18.1045695 1,17 L1,3 L1,3 C1,1.8954305 1.8954305,1 3,1 Z"></path>
                          <polyline points="4 11 8 15 16 6"></polyline>
                        </svg>
                      </div>
                      <span>&nbsp;Agree</span>
                    </label>
                  </div>
                </div> */}
              </div>

              {this.state.errorOnSubmitData && <span className="error-helper">{this.state.errorOnSubmitData}</span>}

              <div className="row">
                <div className="col-5">
                  <button onClick={(e) => {
                    e.preventDefault();
                    this.goTo(this.state.steps[selectedPage].back);
                  }} className="button button-form"><i className="icon fas fa-angle-left"></i></button>
                </div>
                <div className="col-7" style={{ textAlign: 'right'}}>
                  <button
                    type="submit"
                    disabled={(!canSubmit || this.state.loadingSubmitData) ? true : false} 
                    className="button button-form"
                  >
                    <span>Submit</span>{this.state.loadingSubmitData ? <Loader height={20} strokeWidth={3} stroke={'#fff'} />: ''}
                  </button>
                </div>
              </div>
            </Formsy>
          </div>
        )
        break;
      }
      case 5: {
        return (
          <div className="scroller_section register form">
            <div className="row register_license results">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="register-text_success">{this.state.successOnSubmitData}</h3>
                </div>
                <div className="col-sm-12">
                  <button onClick={(e) => {
                    e.preventDefault();
                    const steps = this.props.stepsRegister.map(step => ({ ...step, success: false }));
                    this.props.onDisableValidation();
                    this.setState({
                      ...defaultState,
                      steps,
                    }, () => {
                      this.props.resetRelated();
                    });
                  }} className="button button-form">OK</button>
                </div>
              </div>
            </div>
          </div>
        );
        break;
      }
      default:
        element = <div></div>;
    }

    return element;
  }

  render() {
    return (
      <Fragment>
        <h3 className="content_title">{this.state.title ? this.state.title : 'Register or Update'}</h3>
        <div className="scroller">
          <div className="scroller_body" id="scroller-validation">
            {this.state.page > 0 ? <Steps steps={this.state.steps} completed={this.state.completed} active={this.state.page} /> : null}
            {this._renderRegisterSection()}
          </div>
        </div>
      </Fragment>
    )
  }
}
Register.defaultProps = {}
Register.propTypes = {}


// WEBPACK FOOTER //
// ./src/components/Register.js